export default __webpack_public_path__ + "static/nemecko-615f36f93e40e2f166510f9a5a1a8240.webp";